import { Modal } from 'bootstrap'

// Make Modal available to .js.erb scripts, which cannot do their own imports
window.Modal = Modal
